import { defineComponent as i, createBlock as n, openBlock as l, unref as e, withCtx as t, renderSlot as s, createVNode as o, createTextVNode as c, toDisplayString as d } from "vue";
import { ScalarMarkdown as m } from "@scalar/components";
import p from "../../Section/SectionContainerAccordion.vue.js";
import f from "../../Section/SectionHeader.vue.js";
import u from "../../Anchor/Anchor.vue.js";
import g from "../../Section/SectionHeaderTag.vue.js";
const B = /* @__PURE__ */ i({
  __name: "ClassicLayout",
  props: {
    tag: {}
  },
  setup(_) {
    return (a, S) => (l(), n(e(p), { class: "tag-section" }, {
      title: t(() => {
        var r;
        return [
          o(e(f), { class: "tag-name" }, {
            default: t(() => [
              o(e(u), {
                id: a.tag.id
              }, {
                default: t(() => [
                  o(e(g), { level: 2 }, {
                    default: t(() => [
                      c(d(a.tag.title), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["id"])
            ]),
            _: 1
          }),
          o(e(m), {
            class: "tag-description",
            value: (r = a.tag.tag) == null ? void 0 : r.description,
            withImages: ""
          }, null, 8, ["value"])
        ];
      }),
      default: t(() => [
        s(a.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }));
  }
});
export {
  B as default
};
